import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainGestorv1 from './pages/MainGestorv1';
import AprovedPayment from './pages/AprovedPayment';
import RejectedPaymentP from './pages/RejectedPaymentP';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/Home/MainGestor_v1" element={<MainGestorv1 />} />
        <Route path="/Home/AprovedPayment" element={<AprovedPayment />} />
        <Route path="/Home/RejectedPayment" element={<RejectedPaymentP />} />
      </Routes>
    </Router>
  );
}

export default App;
